import getStaticFile from '@helpers/bucket';

const DARK_THEME_PATH = 'icons/darkTheme/checkout';
const LIGHT_THEME_PATH = 'icons/lightTheme/checkout';
const NO_THEME_PATH = 'icons/noTheme/checkout';

export const NupayLogo = {
  alt: 'Logo da NuPay',
  light: {
    src: getStaticFile({ path: LIGHT_THEME_PATH, fileName: 'payment-nupay-logo.svg' }),
    height: 26,
    width: 85,
  },
  blackFriday: {
    src: getStaticFile({ path: DARK_THEME_PATH, fileName: 'payment-nupay-logo.svg' }),
    height: 26,
    width: 85,
  },
  dark: {
    src: getStaticFile({ path: DARK_THEME_PATH, fileName: 'payment-nupay-logo.svg' }),
    height: 26,
    width: 85,
  },
};

const PIX_ICON = {
  src: getStaticFile({ path: NO_THEME_PATH, fileName: 'pix-logo.svg' }),
  height: 26,
  width: 85,
};

export const PixLogo = {
  alt: 'Logo do Pix',
  light: PIX_ICON,
  blackFriday: PIX_ICON,
  dark: PIX_ICON,
};
